import { Component } from "react"
import "./PremiumPage.css"


class FeatureList extends Component {
    render() {
        return (
            <ul className="plan-features">
                <li><span className="plan-check">&#10003;</span> Unlimited valuations</li>
                <li><span className="plan-check">&#10003;</span> Price trend graphs</li>
                <li><span className="plan-check">&#10003;</span> Access all comparables</li>
                <li><span className="plan-check">&#10003;</span> Neighbourhood insights</li>
                <li><span className="plan-check">&#10003;</span> Lifetime access — pay once, use forever</li>
            </ul>
        )
    }
}

export default FeatureList
